var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search-icon@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9765628,14.4715628 L15.1865628,14.4715628 L14.9065628,14.2015628 C16.1065628,12.8015628 16.7265628,10.8915628 16.3865628,8.8615628 C15.9165628,6.0815628 13.5965628,3.8615628 10.7965628,3.5215628 C6.5665628,3.0015628 3.0065628,6.5615628 3.5265628,10.7915628 C3.8665628,13.5915628 6.0865628,15.9115628 8.8665628,16.3815628 C10.8965628,16.7215628 12.8065628,16.1015628 14.2065628,14.9015628 L14.4765628,15.1815628 L14.4765628,15.9715628 L18.7265628,20.2215628 C19.1365628,20.6315628 19.8065628,20.6315628 20.2165628,20.2215628 C20.6265628,19.8115628 20.6265628,19.1415628 20.2165628,18.7315628 L15.9765628,14.4715628 Z M9.9765628,14.4715628 C7.4865628,14.4715628 5.4765628,12.4615628 5.4765628,9.9715628 C5.4765628,7.4815628 7.4865628,5.4715628 9.9765628,5.4715628 C12.4665628,5.4715628 14.4765628,7.4815628 14.4765628,9.9715628 C14.4765628,12.4615628 12.4665628,14.4715628 9.9765628,14.4715628 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Test-screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-1219.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1180.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "action-/-search_24px",
    transform: "translate(36.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FAFAFA",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon2X);
export default __webpack_public_path__ + "static/media/search-icon@2x.90ff003834085d614ff42e406c4d9ffb.svg";
export { ForwardRef as ReactComponent };